import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Constants from '../Constants';
import wordmark from '../assets/menu-wordmark.png';

function EmailVerifiedView() {
	const navigate = useNavigate();

	const planJSON = localStorage.getItem(Constants.SIGNUP_SELECTED_PLAN);
	const pending_checkout = planJSON ? JSON.parse(planJSON) : null;

	const render_checkout_content = () => {
		return (
			<div className="text-center">
				<p className="email-verification-text">
					Your email has been verified. You are ready to complete your purchase.
				</p>
				<p className="email-verified-plan-name">{pending_checkout.name}</p>
				<p className="email-verified-plan-price">{'$' + (pending_checkout.price_in_cents / 100).toFixed(2) + ' / ' + Constants.get_billing_interval_label(pending_checkout.billing_interval)}</p>
				<Button variant="primary" onClick={function() { return navigate('/payment'); }}>Checkout</Button>
			</div>
		);
	};

	const render_default_content = () => {
		return (
			<React.Fragment>
				<div className="text-center">
					<p className="email-verification-text">
						Your email address has been verified, thank you. <br />You can now proceed to login.
					</p>
				</div>
				<Row>
					<Button variant="primary" onClick={function() { return navigate('/login'); }}>Ok</Button>
				</Row>
			</React.Fragment>
		);
	};

	return (
		<Container fluid className="auth-container">
			<Row className="auth-row">
				<Col lg={4} md={6} sm={10} xs={11}>
					<Card className="auth-card">
						<Card.Body className="auth-card-body">
							<Row>
								<img src={wordmark} className="signin-logo" />
								<h3 className="auth-title">Email Verified</h3>
							</Row>
							<Row>
								{pending_checkout ? render_checkout_content() : render_default_content()}
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default EmailVerifiedView;
